import * as Reducer from './slice';

export interface IAppState {
  // this feature state
  [Reducer.statePropName]: Reducer.IHighscoresState;
  // other features we don't care of
  [otherKeys: string]: any;
}

const getFeatureState = (state: IAppState) => state[Reducer.statePropName];

export const isLoading = (state: IAppState) => getFeatureState(state).loading;

// returns current exercise id
export const getExerciseId = (state: IAppState) => getFeatureState(state).exerciseId;

// returns current exercise id
export const getChallengeFlag = (state: IAppState) => getFeatureState(state).isChallenge;

// returns current page of highscores
export const getHighscoresPage = (state: IAppState) => getFeatureState(state).page;

// returns total amount of users in the current highscore
export const getTotalUsers = (state: IAppState) => getFeatureState(state).totalUsers;

// returns ranking for current user
export const getCurrentUser = (state: IAppState) => getFeatureState(state).currentUser;

// returns rankings for current page and filter
export const getHighscores = (state: IAppState) => getFeatureState(state).userList;

// returns current filter
export const getFilter = (state: IAppState) => getFeatureState(state).filter;
